import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faVolumeHigh,
  faStop,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { AudioPlayerState } from '../Context/AudioContext';

interface ReadAloudIconProps {
  playbackState: AudioPlayerState;
  isPlaybackLoaded: boolean;
  onPlayClick: () => void;
  onStopClick: () => void;
  className?: string;
  buttonClassName?: string;
  iconClassName?: string;
}

const ReadAloudIcon: React.FC<ReadAloudIconProps> = ({
  playbackState,
  isPlaybackLoaded,
  onPlayClick,
  onStopClick,
  className = 'flex flex-col justify-start',
  buttonClassName = 'p-0.5 rounded cursor-pointer',
  iconClassName = 'h-4 w-4 text-gray-600',
}) => {
  return (
    <div className={className}>
      <button
        onClick={(e) => {
          e.stopPropagation();
          if (playbackState === AudioPlayerState.Play) {
            onStopClick();
          } else {
            onPlayClick();
          }
        }}
        className={buttonClassName}
        title={
          playbackState === AudioPlayerState.Play
            ? 'Stop reading'
            : 'Read aloud'
        }
      >
        <FontAwesomeIcon
          icon={
            !isPlaybackLoaded && playbackState === AudioPlayerState.Play
              ? faSpinner
              : playbackState === AudioPlayerState.Play
                ? faStop
                : faVolumeHigh
          }
          className={`${iconClassName} ${!isPlaybackLoaded && playbackState === AudioPlayerState.Play ? 'fa-spin' : ''}`}
        />
      </button>
    </div>
  );
};

export default ReadAloudIcon;
